import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import { ComplainsModalLoader } from '../ComplainsModalLoader';
import { ModalComplainsLoadError } from '../ModalComplainsLoadError';
import { useModerationComplaint } from '../hooks/useModerationComplaint';
import { IOffer } from 'shared/types/offers';

type ComplaintModalContentProps = {
  onCloseModal(): void;
  offer: IOffer;
};

export const ComplaintModalContent: React.FC<ComplaintModalContentProps> = ({ onCloseModal, offer }) => {
  const { isLoading, refetch, manifest, offerId, isError } = useModerationComplaint({ onCloseModal, offer });

  if (isError) {
    return <ModalComplainsLoadError isLoading={isLoading} refetch={refetch} />;
  }

  if (!manifest) {
    return <ComplainsModalLoader />;
  }

  return (
    <Microfrontend
      image={manifest.imageVersion}
      name={manifest.microfrontendName}
      parameters={{ offerId }}
      runtime={manifest.runtimeName}
    />
  );
};
